import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public isShow = true;
  public checkdata: any;
  public isAdmin=false;
  public isSystemAdmin=false;
  constructor(private router: Router, private route: ActivatedRoute, private service: ApifirstService,private rpcClient: RpcClientService) { }

  ngOnInit(): void {
    localStorage.setItem("component",'');
    this.rpcClient.checkFDRSConnectionStatus();
    this.service.showAdminTab.subscribe((data)=> {
      this.isSystemAdmin = data;
    })
    this.service.showSBDAdminTab.subscribe((data)=> {
      this.isAdmin = data;
    })
  }

  targetEngineOverride() {
    this.router.navigate(['updateOverrideForm.do'], { relativeTo: this.route });
  }
  targetEngineTest() {
    this.router.navigate(['targetingEngineTest.do'], { relativeTo: this.route });
  }
  targetEngineStatus() {
    this.router.navigate(['teStatusPage.do'], { relativeTo: this.route });
  }
  variantSummary() {
    this.router.navigate(['variantSummary.do'], { relativeTo: this.route });
  }
  gtacTemplate() {
    this.router.navigate(['gtacTemplate.do'], { relativeTo: this.route });
  }
  reports(){
    this.router.navigate(['reports.do'], {relativeTo: this.route});
  }

  programOverrideOdl() {
    this.router.navigate(['updateDynamicOdlForm.do'], { relativeTo: this.route });
  }
  manageUserQualifier() {
    this.router.navigate(['manageRoleQualifiers.do'], { relativeTo: this.route });
  }
  manageUser() {
    this.router.navigate(['manageuser'], { relativeTo: this.route });
  }
  adhoc() {
    this.router.navigate(['adhoc'], { relativeTo: this.route });
  }
  globalManagedServices() {
    this.router.navigate(['globalManagedServices'], { relativeTo: this.route });
  }
  addrole() {
    this.router.navigate(['addrole'], { relativeTo: this.route });
  }
  sbdrdsmapping() {
    this.router.navigate(['sbdrdsmapping'], { relativeTo: this.route });
  }
  oauthrealmcred() {
    this.router.navigate(['oauthrealmcred'], { relativeTo: this.route });
  }
  scheduleJob() {
    this.router.navigate(['scheduleJob'], { relativeTo: this.route });
  }
  automationTool() {
    this.router.navigate(['automation'], { relativeTo: this.route });
  }
  adfsProfiles(){
    this.router.navigate(['adfsProfiles'], { relativeTo: this.route });
  }
  adfsClients(){
    this.router.navigate(['adfsClients'], { relativeTo: this.route });
  }
  adfsWebserives(){
  this.router.navigate(['adfsWebserives'], { relativeTo: this.route });
  }
  featuremappings(){
    this.router.navigate(['featuremappings'], { relativeTo: this.route });
    }

}
